/**
 * HideAddedToCart - A class for showing a notification about items added to the cart
 */
class HideAddedToCart {
	/**
	 * Setup method
	 * Static method to set up the class on the page
	 *
	 * @return {void}
	 */
	static setup() {
		const addedToCartElem = document.querySelector('.qte-added-to-cart-message');
		if (addedToCartElem) {
			setTimeout(() => {
				addedToCartElem.classList.add('fade-out');

				addedToCartElem.addEventListener('transitionend', () => {
					addedToCartElem.remove();
				});
			}, 15000);
		}

		// Check if notary-added-to-cart query parameter is present. If so, remove it from the URL.
		const urlParams = new URLSearchParams(window.location.search);
		if (urlParams.has('notary-added-to-cart')) {
			const newParams = urlParams;
			newParams.delete('notary-added-to-cart');

			const queryString = newParams.toString();
			const newUrl = queryString
				? `${window.location.pathname}?${queryString}${window.location.hash}`
				: `${window.location.pathname}${window.location.hash}`;

			window.history.replaceState({}, '', newUrl);
		}
	}
}

// Setup on document ready
if (document.readyState === 'interactive' || document.readyState === 'complete') {
	HideAddedToCart.setup();
} else {
	document.addEventListener('DOMContentLoaded', HideAddedToCart.setup);
}
